import React from "react";
import { connect } from "react-redux";

import {
    Form,
    FormElement,
    FormValidator,
    CustomTextControl,
    BaseReactComponent,
    SelectControl
} from "../../utils/form";
import { Row, Col, Button, Image } from "react-bootstrap";
import ComponentHeader from "../common/ComponentHeader";
import "react-datepicker/dist/react-datepicker.css";
import { ClearButton, ImageUploader } from "../common";
import { getAllUploadSectionApi, getCommonApi, postAuthCommonApi, putAuthCommonApi } from "../content/Api";
import ReactDOM from "react-dom";
import { durationObj, MAX_LIMIT, MODULES, MUTUAL_FUND_COMPANY, selectLogoPosition, } from "../../utils/Constant";
import { s3UrlToFile, filterVerifiedItems, userAmcUuids, userCreatorUuids, userRoleType } from "../../utils/ReusableFunctions";
import { SearchContent } from "../content";
import { toast } from "react-toastify";
import { getAllAmcSsoApi, getAllCreatorApi, getAllModulesApi, getAllTypeApi, getDetailsSsoApi, getAllToolsApi, getPersonalizationCategoryApi, getAllPersonalizationCalendarApi } from "./Api";
import { getAllSubscriptionsApi } from "../subscription/Api";
import { getTargetedContentSubdomainApi } from "../subdomain/Api";
import closeIcon from '../../assets/images/close.png';
import { getAllCategoryApi, getLanguageNameApi } from "../MasterCategory/Api";
import { getCampaignByFilterApi } from "../contentCollections/Api";
import { getEventsByFilterApi } from "../events/Api";
import ColorPicker from "react-best-gradient-color-picker";
import PopoverColorPicker from "../../utils/form/ColorPicker";
import { withRouter } from "../../utils/hoc/withRouter";


const cobrandPermissionConfig = [
    {
        label: "Save Custom Templates",
        stateKey: "isCustomTemplateAllowed",
    },
    {
        label: "Set Default Template",
        stateKey: "isDefaultTemplateSelectable",
    },
    {
        label: "Select Templates",
        stateKey: "isCobrandTemplateSelectable",
    },
];

const profilePermissionConfig = [
    {
        label: "Edit Profile",
        stateKey: "isEditProfileAllowed",
    },
    {
        label: "Edit Company Details",
        stateKey: "isEditCompanyDetailsAllowed",
    },
];



class AddEditPartners extends BaseReactComponent {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                partnerType: "",
                companyName: "",
                websiteLink: "",
                emailAddress: "",
                mobileNumber: "",
                type: "",
                logo: null,
                loginLeftImage: null,
                planConfiguration: {
                    allowSubscriptionPlanPage: null,
                    isTFPAllowed: null,
                    subscriptionPlanPageLink: "",
                    allowedPremiumPlans: [],
                },
                adminPanelConfiguration: {
                    allowPartnerAdminPanel: null,
                    allowPartnerAdminUserDetails: null,
                },
                companyLogoConfiguration: {
                    companyLogoVisibility: null,
                    companyLogoText: "",
                    where: "",
                    logoPosition: "",
                },
                defaultPlanConfiguration: {
                    premiumPlanUuid: "",
                    subPremiumPlanUuid: "",
                    subPremiumPlanVariationUuid: "",
                },
                ssoConfiguration: {
                    isParentChildrenAllowed: null,
                    canUpdateProfile: null,
                    allowChildrenMemebershipPage: null,
                    isEditProfileAllowed: {
                        PARENT: false,
                        CHILD: false,
                    },
                    isEditCompanyDetailsAllowed: {
                        PARENT: false,
                        CHILD: false,
                    },
                    isCobrandTemplateSelectable: {
                        PARENT: false,
                        CHILD: false,
                    },
                    isDefaultTemplateSelectable: {
                        PARENT: false,
                        CHILD: false,
                    },
                    isCustomTemplateAllowed: {
                        PARENT: false,
                        CHILD: false,
                    }
                },
                subDomainConfiguration: {
                    favicon: null,
                    pageTitle: "",
                    pageDescription: "",
                },
                contentCreators: [],
                amcs: [],
                modules: [],
                theme: {
                    primaryBg: "#270082",
                    primaryText: "#ffffff",
                    primaryBtnBg: "#270082",
                    primaryBtnText: "#ffffff",
                },
                isTfpContentVisible: false,
            },
            loading: this.props?.match?.params?.uuid ? true : false,
            formLoading: false,
            modulesList: [],
            creatorList: [],
            organizerList: [],
            amcOption: [],
            typesOptions: [],
            plansData: [],
            isAddContent: true,
            targetedContentOptions: [],
            personalizationCategoryOptions: [],
            uploadSectionOptions: [],
        };
        this.typeOptions = [{ label: "SSO Partner", value: "ssoPartner" }, { label: "Subdomain", value: "subDomain" }];
        this.partnerTypes = { sso: "ssoPartner", subdomain: "subDomain" }
        this.logoOptions = [{ label: "Only Company", value: "self" }, { label: "Company With TFP", value: "both" }]
    };



    addMore = () => {
        let modules = [...this.state.data.modules];
        modules.push({ moduleName: "" });
        this.setState({ data: { ...this.state.data, modules } });
    }
    removeModules = (idx) => {
        let modules = [...this.state.data.modules];
        modules = modules.filter((module, i) => i !== idx)
        this.setState({ data: { ...this.state.data, modules } });
    }

    async componentDidMount() {
        var planOptions
        this.props.getAllAmcSsoApi(this);
        this.props.getAllTypeApi(this);
        this.props.getAllModulesApi(this);
        this.props.getAllCategoryApi(this);
        this.props.getTargetedContentSubdomainApi(this, {});
        this.props.getPersonalizationCategoryApi(this);
        this.props.getLanguageNameApi(this, null, true);
        getAllToolsApi(this);
        getAllPersonalizationCalendarApi(this);
        getAllUploadSectionApi(this)
        getAllCreatorApi(this, "content");
        getAllCreatorApi(this, "event");
        getCampaignByFilterApi({}).then((res) => {
            let option = res?.map((item) =>
            ({
                label: item.campaignName,
                value: item.uuid,
            }));
            this.setState({ campaignOptions: option || [] });
        });
        await getCommonApi(`premium-plan?pageSize=${MAX_LIMIT}`).then((res) => {
            this.setState({ plansData: filterVerifiedItems(res.data.data.list) });
            planOptions = filterVerifiedItems(res?.data?.data?.list)

        });
        if (this.props.match?.params.uuid) {
            this.setState({ loading: true })
            await getDetailsSsoApi("/sso", this, true, planOptions).finally(() => {
                this.setState({ loading: false })
            });
        };
    }

    componentDidUpdate(prevProps, prevState) {


    }


    handleSave = () => {
        ReactDOM.findDOMNode(this.form).dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
        );
    };

    validate = async () => {
        //  everything is compulasy if the field is visible
        const { data } = this.state;
        if (!data.partnerType) {
            return "Partner Type cannot be empty";
        }
        if (!data.companyName) {
            return "Company Name cannot be empty";
        }
        if (!data.mobileNumber) {
            return "Mobile Number cannot be empty";
        }
        if (!data.emailAddress) {
            return "Email cannot be empty";
        }
        if (data.emailAddress && !FormValidator.isEmail(data.emailAddress)) {
            return "Enter valid email";
        }
        if (data.partnerType === this.partnerTypes.subdomain && !data.websiteLink) {
            return "Subdomain Link cannot be empty";
        }
        if (data.partnerType === this.partnerTypes.sso && !data.type) {
            return "Type cannot be empty";
        }
        if (!data.logo) {
            return "Logo cannot be empty";
        }
        if (!data.defaultPlanConfiguration.premiumPlanUuid) {
            return "Membership Name cannot be empty";
        }
        if (!data.defaultPlanConfiguration.subPremiumPlanUuid) {
            return "Plan Name cannot be empty";
        }
        if (!data.defaultPlanConfiguration.subPremiumPlanVariationUuid) {
            return "Variation cannot be empty";
        }
        if (data.companyLogoConfiguration.companyLogoVisibility === null) {
            return "Please select show company logo on header";
        }
        if (data.companyLogoConfiguration.companyLogoVisibility === true && !data.companyLogoConfiguration.where) {
            return "Please select show logo of";
        }
        if (data.companyLogoConfiguration.companyLogoVisibility === true && data.companyLogoConfiguration.where === "both" && !data.companyLogoConfiguration.companyLogoText) {
            return "Please select text on logo";
        }
        if (data.planConfiguration.allowSubscriptionPlanPage === null) {
            return "Please select allow subscription plan page";
        }
        if (data.planConfiguration.allowSubscriptionPlanPage === true) {
            if (data.planConfiguration.isTFPAllowed === null) {
                return "Please select subscription plan";
            }
            if (data.planConfiguration.isTFPAllowed === false && !data.planConfiguration.subscriptionPlanPageLink) {
                return "Please enter other link";
            }
        }
        if (data.adminPanelConfiguration.allowPartnerAdminPanel === null) {
            return "Please select allow partner admin panel";
        }
        if (data.adminPanelConfiguration.allowPartnerAdminPanel === true && data.adminPanelConfiguration.allowPartnerAdminUserDetails === null) {
            return "Please select allow partner admin user details";
        }

        if (data.partnerType === this.partnerTypes.sso) {
            if (data.ssoConfiguration.isParentChildrenAllowed === null) {
                return "Please select allow parent/children";
            }
            if (data.ssoConfiguration.isParentChildrenAllowed === true) {
                if (data.ssoConfiguration.canUpdateProfile === null) {
                    return "Please select can user update profile";
                }
            }

        }


        return null;

    }

    onValidSubmit = async () => {
        const error = await this.validate();
        if (error) {
            toast.error(error)
            return;
        }

        this.setState({ formLoading: true });

        const { data } = this.state;

        let logoFile = ((data.logo instanceof File || data.logo instanceof Blob)
            ? data.logo
            : await s3UrlToFile(data.logo || "")) || null;
        let leftImageFile = ((data.loginLeftImage instanceof File || data.loginLeftImage instanceof Blob)
            ? data.loginLeftImage
            : await s3UrlToFile(data.loginLeftImage || "")) || null;
        let faviconFile = ((data.subDomainConfiguration.favicon instanceof File || data.subDomainConfiguration.favicon instanceof Blob)
            ? data.subDomainConfiguration.favicon
            : await s3UrlToFile(data.subDomainConfiguration.favicon || "")) || null;

        let processedModules = data.modules.map(item => {
            delete item.masterSsoPartnerModule;
            delete item.code;
            return {
                ...item,
                uuids: (Array.isArray(item.uuids) && item.uuids?.length > 0) ? item.uuids.join(",") : "",
                eventOrganizer: (Array.isArray(item.eventOrganizer) && item.eventOrganizer?.length > 0) ? item.eventOrganizer.join(",") : "",
                eventAmcs: (Array.isArray(item.eventAmcs) && item.eventAmcs?.length) > 0 ? item.eventAmcs.join(",") : "",
                uploadSections: (Array.isArray(item.uploadSections) && item.uploadSections?.length > 0) ? item.uploadSections.join(",") : "",
                personalizationCategory: (Array.isArray(item.personalizationCategory) && item.personalizationCategory?.length > 0) ? item.personalizationCategory.join(",") : "",
            }
        });
        const ssoData = {
            "companyName": data.companyName,
            "emailAddress": data.emailAddress,
            "mobileNumber": data.mobileNumber,
            "websiteLink": data.websiteLink,
            "ssoPartnerTypeUuid": data.type,
            "type": data.partnerType,
            // "companyLogo": logoFile ? logoFile.name : "",
            // "favicon": faviconFile ? faviconFile.name : "",
            "pageTitle": data.subDomainConfiguration.pageTitle || "",
            "pageDescription": data.subDomainConfiguration.pageDescription || "",
            "logoPosition": data.companyLogoConfiguration.logoPosition || "",
            // "loginLeftImage": leftImageFile ? leftImageFile.name : "",
            // modules
            "amcs": data.amcs?.length > 0 ? data.amcs.join(",") : "",
            "contentCreators": data.contentCreators?.length > 0 ? data.contentCreators.join(",") : "",
            "modules": processedModules,
            // default plan configuration
            "premiumPlanUuid": data.defaultPlanConfiguration.premiumPlanUuid,
            "subPremiumPlanUuid": data.defaultPlanConfiguration.subPremiumPlanUuid,
            "subPremiumPlanVariationUuid": data.defaultPlanConfiguration.subPremiumPlanVariationUuid,
            // plan configuration
            "allowSubscriptionPlanPage": data.planConfiguration.allowSubscriptionPlanPage,
            "subscriptionPlanPageLink": data.planConfiguration.isTFPAllowed ? "" : data.planConfiguration.subscriptionPlanPageLink,
            "allowedSubPremiumPlans": data.planConfiguration.isTFPAllowed ? data.planConfiguration.allowedPremiumPlans.map(item => item.subPremiumPlanUuid).join(",") : "",
            "allowedSubPremiumPlanVariations": data.planConfiguration.isTFPAllowed ? data.planConfiguration.allowedPremiumPlans.map(item => item.subPremiumPlanVariationUuids).flat().join(",") : "",
            // admin panel configuration
            "allowPartnerAdminPanel": data.adminPanelConfiguration.allowPartnerAdminPanel,
            "allowPartnerAdminUserDetails": data.adminPanelConfiguration.allowPartnerAdminPanel ? data.adminPanelConfiguration.allowPartnerAdminUserDetails : false,
            "theme": data.theme,
            "isTfpContentVisible": data.isTfpContentVisible || false,
        }
        if (logoFile) {
            ssoData.companyLogo = logoFile ? logoFile.name : "";
        }
        if (leftImageFile) {
            ssoData.loginLeftImage = leftImageFile ? leftImageFile.name : "";
        }
        if (faviconFile) {
            ssoData.favicon = faviconFile ? faviconFile.name : "";
        }

        if (data.partnerType === this.partnerTypes.sso) {
            ssoData.allowParentChildren = data.ssoConfiguration.isParentChildrenAllowed;
            ssoData.canUserUpdateProfile = data.ssoConfiguration.canUpdateProfile;
            ssoData.allowChildrenMemebershipPage = data.ssoConfiguration.allowChildrenMemebershipPage;
            ssoData.isEditProfileAllowed = data.ssoConfiguration.isEditProfileAllowed;
            ssoData.isEditCompanyDetailsAllowed = data.ssoConfiguration.isEditCompanyDetailsAllowed;
            ssoData.isCobrandTemplateSelectable = data.ssoConfiguration.isCobrandTemplateSelectable;
            ssoData.isDefaultTemplateSelectable = data.ssoConfiguration.isDefaultTemplateSelectable;
            ssoData.isCustomTemplateAllowed = data.ssoConfiguration.isCustomTemplateAllowed;
        }
        if (data.logo) {
            ssoData.companyLogoVisibility = data.companyLogoConfiguration.companyLogoVisibility;
            ssoData.companyLogoText = data.companyLogoConfiguration.companyLogoVisibility ? data.companyLogoConfiguration.where === "both" ? data.companyLogoConfiguration.companyLogoText : "" : "";
        }

        const formData = new FormData();
        formData.append("key", JSON.stringify({ data: { ...ssoData } }));
        if (logoFile) {
            formData.append("file", logoFile);
        }
        if (leftImageFile) {
            formData.append("file", leftImageFile);
        }
        if (faviconFile) {
            formData.append("file", faviconFile);
        }
        const editUuid = this.props.match?.params.uuid || false;
        let url = editUuid ? `/sso/${editUuid}` : "/sso";
        let instance = editUuid ? putAuthCommonApi : postAuthCommonApi;

        const success = await instance(url, formData)
        this.setState({ formLoading: false });
        if (success) {
            // Came from the partners list: go back so page/search/filters are preserved
            if (this.props.location?.state) {
                this.props.history(-1);
            } else {
                this.props.history({ pathname: `/partners`, search: '?page=1&pageSize=10' });
            }
        }
    };

    addPlan = () => {
        let allowedPremiumPlans = [...this.state.data.planConfiguration.allowedPremiumPlans];
        allowedPremiumPlans.push({ subPremiumPlanUuid: "" });
        this.setState({ data: { ...this.state.data, planConfiguration: { ...this.state.data.planConfiguration, allowedPremiumPlans } } });
    }
    removePlan = (idx) => {
        let allowedPremiumPlans = [...this.state.data.planConfiguration.allowedPremiumPlans];
        allowedPremiumPlans = allowedPremiumPlans.filter((plan, i) => i !== idx)
        this.setState({ data: { ...this.state.data, planConfiguration: { ...this.state.data.planConfiguration, allowedPremiumPlans } } });
    }

    render() {
        const { data, loading, plansData } = this.state;
        const { sso, subdomain } = this.partnerTypes;

        const subPremiumPlansOptions = (plansData || []).reduce((acc, plan) => {
            if (Array.isArray(plan?.subPremiumPlan) && plan.subPremiumPlan.length > 0) {
                const mappedSubPlans = plan.subPremiumPlan.map(subPlan => ({
                    value: subPlan.uuid,
                    label: subPlan.name,
                    variations: subPlan.subPremiumPlanVariation.map(variation => ({
                        value: variation.uuid,
                        label: variation.pack ? variation.pack : durationObj[variation.resetInDays],
                    })),
                }));
                acc.push(...mappedSubPlans);
            }
            return acc;
        }, [])
        console.log(plansData);
        console.log(this.state);
        if (loading) {
            return (
                <section className="add-section">
                    <ComponentHeader
                        title={"Loading Partner Form..."}
                        isSearch={false}
                        isBackArrow={true}
                        isReturn="/partners?pageSize=10&pageNumber=1"
                        handlePrimaryBtn={this.handleSave}
                    />
                </section>
            )
        }
        return (
            <section className="add-section">
                <ComponentHeader
                    title={this.props?.match?.params?.uuid ? "Update Partner" : "Add Partner"}
                    primaryBtn="Save"
                    isSearch={false}
                    isBackArrow={true}
                    resLoading={this.state.formLoading}
                    isReturn="/partners?pageSize=10&pageNumber=1"
                    handlePrimaryBtn={this.handleSave}
                />
                <Form ref={(el) => (this.form = el)} onValidSubmit={this.onValidSubmit}>
                    <Row>
                        <Col md={4}>
                            <FormElement
                                valueLink={this.linkState(this, "data.partnerType")}
                                label="Partner Type"
                                required
                                validations={[
                                    {
                                        validate: FormValidator.isRequired,
                                        message: "Partner cannot be empty",
                                    },
                                ]}
                                control={{
                                    type: SelectControl,
                                    settings: {
                                        placeholder: "Enter Partner Type",
                                        options: this.typeOptions || [],
                                    },
                                }}
                            />
                        </Col>
                        <Col md={4}>
                            <FormElement
                                valueLink={this.linkState(this, "data.companyName")}
                                label="Company Name"
                                required
                                validations={[
                                    {
                                        validate: FormValidator.isRequired,
                                        message: "Name cannot be empty",
                                    },
                                ]}
                                control={{
                                    type: CustomTextControl,
                                    settings: {
                                        placeholder: "Enter Company Name",
                                    },
                                }}
                            />
                        </Col>


                        <Col md={4}>
                            <FormElement
                                valueLink={this.linkState(this, "data.mobileNumber")}
                                label="Mobile Number"
                                required
                                validations={[
                                    {
                                        validate: FormValidator.isRequired,
                                        message: "Mobile Number cannot be empty",
                                    },

                                    {
                                        validate: FormValidator.isNumber,
                                        message: "Enter valid number",
                                    },
                                ]}
                                control={{
                                    type: CustomTextControl,
                                    settings: {
                                        placeholder: "Enter Mobile Number",
                                    },
                                }}
                            />
                        </Col>
                        <Col md={4}>
                            <FormElement
                                valueLink={this.linkState(this, "data.emailAddress")}
                                label="Email"
                                required
                                validations={[
                                    {
                                        validate: FormValidator.isRequired,
                                        message: "Email cannot be empty",
                                    },
                                    {
                                        validate: FormValidator.isEmail,
                                        message: "Enter valid email",
                                    },
                                ]}
                                control={{
                                    type: CustomTextControl,
                                    settings: {
                                        placeholder: "Enter Email",
                                    },
                                }}
                            />
                        </Col>
                        <Col sm={4}>
                            <ImageUploader required={true} id="Thumbnail" label="Upload Logo" name={((data?.logo instanceof File || data?.logo instanceof Blob)
                                ? URL.createObjectURL(data.logo)
                                : data?.logo || "")} onChange={(e) => this.setState({ data: { ...data, logo: e.target.files?.[0] } })} onDelete={() => this.setState({ data: { ...data, logo: "" } })} showLabel={false} />
                        </Col>
                        <Col sm={4}>
                            <ImageUploader required={true} id="LeftImage" label="Upload Login Left Image" name={((data?.loginLeftImage instanceof File || data?.loginLeftImage instanceof Blob)
                                ? URL.createObjectURL(data.loginLeftImage)
                                : data?.loginLeftImage || "")} onChange={(e) => this.setState({ data: { ...data, loginLeftImage: e.target.files?.[0] } })} onDelete={() => this.setState({ data: { ...data, loginLeftImage: "" } })} showLabel={false} />
                        </Col>
                        {data.partnerType === subdomain && <Col md={4}>
                            <FormElement
                                valueLink={this.linkState(this, "data.websiteLink")}
                                label="Subdomain Link"
                                required
                                validations={[
                                    {
                                        validate: FormValidator.isRequired,
                                        message: "Link cannot be empty",
                                    },
                                ]}
                                control={{
                                    type: CustomTextControl,
                                    settings: {
                                        placeholder: "Enter Subdomain Link",
                                    },
                                }}
                            />
                        </Col>}
                        {data.partnerType === sso && <Col md={4}>
                            <FormElement
                                valueLink={this.linkState(this, "data.type")}
                                label="Type"
                                required
                                validations={[
                                    {
                                        validate: FormValidator.isRequired,
                                        message: "Type cannot be empty",
                                    },
                                ]}
                                control={{
                                    type: SelectControl,
                                    settings: {
                                        placeholder: "Select Type",
                                        options: this.state.typesOptions,
                                        multiple: false,
                                        searchable: true,

                                    },
                                }}
                            />
                        </Col>}
                    </Row>
                    {
                        data.logo &&
                        <Row>
                            <Col md={4} className="mt-3 f-s-14 roboto-grey">
                                <p className="mb-2">Show Company Logo on Header? <span class=" text-danger">*</span></p>
                                <label htmlFor={"showlogo"} className="d-inline-block mr-3 pointer" >
                                    <input type="radio" id="showlogo" name="logoVisibility" checked={data?.companyLogoConfiguration?.companyLogoVisibility === true} onChange={() => this.setState({ data: { ...data, companyLogoConfiguration: { ...data.companyLogoConfiguration, companyLogoVisibility: true } } })} /> Yes
                                </label>
                                <label htmlFor={"showlogo2"} className="d-inline-block mr-3 pointer" >
                                    <input type="radio" id={"showlogo2"} name="logoVisibility" checked={data?.companyLogoConfiguration?.companyLogoVisibility === false} onChange={() => this.setState({ data: { ...data, companyLogoConfiguration: { ...data.companyLogoConfiguration, companyLogoVisibility: false } } })} /> No
                                </label>
                            </Col>
                            {data?.companyLogoConfiguration?.companyLogoVisibility === true &&
                                <Col md={4} className="mt-3 f-s-14 roboto-grey">
                                    <p className="mb-2">Show Logo Of <span class=" text-danger">*</span></p>
                                    {this.logoOptions.map((item, i) => (
                                        <label htmlFor={"logo" + i} key={i} className="d-inline-block mr-3 pointer" >
                                            <input type="radio" id={"logo" + i} name="where" checked={data?.companyLogoConfiguration?.where === item.value} onChange={() => this.setState({ data: { ...data, companyLogoConfiguration: { ...data.companyLogoConfiguration, where: item.value } } })} /> {item.label}
                                        </label>
                                    ))}
                                </Col>}

                            {
                                data?.companyLogoConfiguration?.companyLogoVisibility === true && data?.companyLogoConfiguration?.where === "both" &&
                                <Col md={4} className="mt-3 f-s-14 roboto-grey">
                                    <p className="mb-2">Text on Logo<span class=" text-danger">*</span></p>
                                    <label htmlFor={"poweredBy"} className="d-inline-block mr-3 pointer" >
                                        <input type="radio" id={"poweredBy"} name="logoText" checked={data?.companyLogoConfiguration?.companyLogoText === "Powered by"} onChange={() => this.setState({ data: { ...data, companyLogoConfiguration: { ...data.companyLogoConfiguration, companyLogoText: "Powered by" } } })} /> Powered by
                                    </label>
                                    <label htmlFor={"broughtToYouBy"} className="d-inline-block mr-3 pointer" >
                                        <input type="radio" id={"broughtToYouBy"} name="logoText" checked={data?.companyLogoConfiguration?.companyLogoText === "Brought to you by"} onChange={() => this.setState({ data: { ...data, companyLogoConfiguration: { ...data.companyLogoConfiguration, companyLogoText: "Brought to you by" } } })} /> Brought to you by
                                    </label>
                                </Col>
                            }
                            {
                                data?.companyLogoConfiguration?.companyLogoVisibility === true &&
                                <Col md={4} className="mt-3 f-s-14">
                                    <p className="mb-1">Logo Position<span class=" text-danger">*</span></p>
                                    <FormElement
                                        valueLink={this.linkState(this, "data.companyLogoConfiguration.logoPosition")}
                                        required
                                        control={{
                                            type: SelectControl,
                                            settings: {
                                                placeholder: "Select Position",
                                                options: selectLogoPosition,
                                                multiple: false,
                                                searchable: false,
                                            },
                                        }}
                                    />
                                </Col>
                            }
                        </Row>
                    }


                    <hr />
                    <Row>
                        <Col md={12}>
                            <label className="primary f-s-18 inter-medium my-3">Default Subscription</label>
                        </Col>

                        {/* Premium Plan */}
                        <Col sm={4}>
                            <FormElement
                                valueLink={this.linkState(this, "data.defaultPlanConfiguration.premiumPlanUuid")}
                                label="Membership Name"
                                required
                                validations={[
                                    { validate: FormValidator.isRequired, message: "Field cannot be empty" },
                                ]}
                                control={{
                                    type: SelectControl,
                                    settings: {
                                        options: plansData?.map((item) => ({ value: item.uuid, label: item.name })),
                                        placeholder: "Select Membership Name",
                                        multiple: false,
                                        searchable: true,
                                        onChangeCallback: (onBlur) => {
                                            onBlur(this.state.data.defaultPlanConfiguration.premiumPlanUuid);

                                            const selectedPlan = plansData?.find(
                                                (ele) =>
                                                    ele.uuid ===
                                                    this.state?.data?.defaultPlanConfiguration?.premiumPlanUuid
                                            );

                                            this.setState({
                                                subPremiumPlans: selectedPlan?.subPremiumPlan || [],
                                                subPremiumPlanVariations: [],
                                                data: {
                                                    ...this.state.data,
                                                    defaultPlanConfiguration: {
                                                        ...this.state.data.defaultPlanConfiguration,
                                                        subPremiumPlanUuid: "",
                                                        subPremiumPlanVariationUuid: "",
                                                    },
                                                },
                                            });
                                        },
                                    },
                                }}
                            />
                        </Col>

                        {/* Sub Premium Plan */}
                        {data.defaultPlanConfiguration.premiumPlanUuid && (
                            <Col sm={4}>
                                <FormElement
                                    valueLink={this.linkState(this, "data.defaultPlanConfiguration.subPremiumPlanUuid")}
                                    label="Plan Name"
                                    required
                                    validations={[
                                        { validate: FormValidator.isRequired, message: "Field cannot be empty" },
                                    ]}
                                    control={{
                                        type: SelectControl,
                                        settings: {
                                            options: this.state.subPremiumPlans?.map((item) => ({
                                                value: item.uuid,
                                                label: item.name,
                                            })),
                                            placeholder: "Select Plan Name",
                                            multiple: false,
                                            searchable: true,
                                            onChangeCallback: (onBlur) => {
                                                onBlur(this.state.data.defaultPlanConfiguration.subPremiumPlanUuid);

                                                const selectedSubPlan = this.state.subPremiumPlans?.find(
                                                    (ele) =>
                                                        ele.uuid ===
                                                        this.state?.data?.defaultPlanConfiguration?.subPremiumPlanUuid
                                                );

                                                this.setState({
                                                    subPremiumPlanVariations:
                                                        selectedSubPlan?.subPremiumPlanVariation || [], // ✅ JSON key fix
                                                    data: {
                                                        ...this.state.data,
                                                        defaultPlanConfiguration: {
                                                            ...this.state.data.defaultPlanConfiguration,
                                                            subPremiumPlanVariationUuid: "",
                                                        },
                                                    },
                                                });
                                            },
                                        },
                                    }}
                                />
                            </Col>
                        )}

                        {/* Variations */}
                        {data.defaultPlanConfiguration.subPremiumPlanUuid && (
                            <Col sm={4}>
                                <FormElement
                                    valueLink={this.linkState(this, "data.defaultPlanConfiguration.subPremiumPlanVariationUuid")}
                                    label="Variation"
                                    required
                                    validations={[
                                        { validate: FormValidator.isRequired, message: "Field cannot be empty" },
                                    ]}
                                    control={{
                                        type: SelectControl,
                                        settings: {
                                            options: this.state.subPremiumPlanVariations?.map((item) => ({
                                                value: item.uuid,
                                                label: durationObj[item.resetInDays], // ✅ use your durationObj mapping
                                            })),
                                            placeholder: "Select Variation",
                                            multiple: false,
                                            searchable: true,
                                            onChangeCallback: (onBlur) => {
                                                onBlur(
                                                    this.state.data.defaultPlanConfiguration.subPremiumPlanVariationUuid
                                                );
                                            },
                                        },
                                    }}
                                />
                            </Col>
                        )}

                        <hr />
                    </Row>
                    <hr />

                    <Row>
                        <Col md={12}>
                            <label className="primary f-s-18 inter-medium my-3">Account Configuration</label>
                        </Col>
                        <Col md={12}>
                            <Row>
                                <Col md={4} className="mt-3 f-s-14 roboto-grey">
                                    <p className="mb-2">Allow Subscription Plan Page<span className="text-danger">*</span></p>
                                    <label htmlFor={"allowSubscriptionPlanPageYes"} className="d-inline-block mr-3 pointer" >
                                        <input type="radio" id="allowSubscriptionPlanPageYes" name="allowSubscriptionPlanPage" checked={data?.planConfiguration?.allowSubscriptionPlanPage === true} onChange={() => this.setState({ data: { ...data, planConfiguration: { ...data.planConfiguration, allowSubscriptionPlanPage: true } } })} /> Yes
                                    </label>
                                    <label htmlFor={"allowSubscriptionPlanPageNo"} className="d-inline-block mr-3 pointer" >
                                        <input type="radio" id={"allowSubscriptionPlanPageNo"} name="allowSubscriptionPlanPage" checked={data?.planConfiguration?.allowSubscriptionPlanPage === false} onChange={() => this.setState({ data: { ...data, planConfiguration: { ...data.planConfiguration, allowSubscriptionPlanPage: false } } })} /> No
                                    </label>
                                </Col>

                                {/* tfp or otherlink use ifTfp allowed  */}
                                <Col md={4} className="mt-3 f-s-14 roboto-grey">
                                    {data?.planConfiguration?.allowSubscriptionPlanPage === true && <>
                                        <p className="mb-2">Subscription Plan? <span class=" text-danger">*</span></p>
                                        <label htmlFor={"isTFPAllowedYes"} className="d-inline-block mr-3 pointer" >
                                            <input type="radio" id="isTFPAllowedYes" name="isTFPAllowed" checked={data?.planConfiguration?.isTFPAllowed === true} onChange={() => this.setState({ data: { ...data, planConfiguration: { ...data.planConfiguration, isTFPAllowed: true, subscriptionPlanPageLink: "" } } })} /> TFP Plans
                                        </label>
                                        <label htmlFor={"isTFPAllowedNo"} className="d-inline-block mr-3 pointer" >
                                            <input type="radio" id={"isTFPAllowedNo"} name="isTFPAllowed" checked={data?.planConfiguration?.isTFPAllowed === false} onChange={() => this.setState({ data: { ...data, planConfiguration: { ...data.planConfiguration, isTFPAllowed: false } } })} /> Other Link
                                        </label>
                                    </>}
                                </Col>
                                {data?.planConfiguration?.allowSubscriptionPlanPage === true && data?.planConfiguration?.isTFPAllowed === true &&
                                    <Col md={12} className="mt-3">
                                        {/* <Row>
                                    <Col md={4}>
                                        <FormElement
                                            valueLink={this.linkState(this, "data.planConfiguration.allowedPremiumPlans")}
                                            label="Select Plan"
                                            required
                                            validations={[
                                                {
                                                    validate: FormValidator.isRequired,
                                                    message: "Premium Plan cannot be empty",
                                                },
                                            ]}
                                            control={{
                                                type: SelectControl,
                                                settings: {
                                                    placeholder: "Select Plan",
                                                    options: subPremiumPlansOptions,
                                                    multiple: false,
                                                    selectAll: true,
                                                    searchable: true,
                                                },
                                            }}
                                        />
                                    </Col>

                                </Row> */}
                                        {
                                            data?.planConfiguration?.allowedPremiumPlans?.map((plan, idx) => (
                                                <Row key={idx} className="align-items-center">
                                                    <Col md={4}>
                                                        <FormElement
                                                            valueLink={this.linkState(this, `data.planConfiguration.allowedPremiumPlans.${idx}.subPremiumPlanUuid`)}
                                                            label={`Select Plan ${idx + 1}`}
                                                            required
                                                            validations={[
                                                                {
                                                                    validate: FormValidator.isRequired,
                                                                    message: "Premium Plan cannot be empty",
                                                                },
                                                            ]}
                                                            control={{
                                                                type: SelectControl,
                                                                settings: {
                                                                    placeholder: "Select Plan",
                                                                    options: subPremiumPlansOptions?.filter(plan => !data?.planConfiguration?.allowedPremiumPlans?.some((p, i) => p.subPremiumPlanUuid === plan.value && i !== idx)),
                                                                    multiple: false,
                                                                    searchable: true,
                                                                    onChangeCallback: (onBlur) => {
                                                                        this.setState(prevState => {
                                                                            const allowedPremiumPlans = [...prevState.data.planConfiguration.allowedPremiumPlans];
                                                                            allowedPremiumPlans[idx].subPremiumPlanVariationUuids = [];
                                                                            return { planConfiguration: { ...data.planConfiguration, allowedPremiumPlans } };
                                                                        });
                                                                    }
                                                                },

                                                            }}
                                                        />
                                                    </Col>
                                                    {
                                                        data?.planConfiguration?.allowedPremiumPlans?.[idx]?.subPremiumPlanUuid &&
                                                        <Col md={4}>
                                                            <FormElement
                                                                valueLink={this.linkState(this, `data.planConfiguration.allowedPremiumPlans.${idx}.subPremiumPlanVariationUuids`)}
                                                                label={`Select Variations for Plan ${idx + 1}`}
                                                                validations={[
                                                                    // {
                                                                    //     validate: FormValidator.isRequired,
                                                                    //     message: "Premium Plan Variation cannot be empty",
                                                                    // },
                                                                ]}
                                                                control={{
                                                                    type: SelectControl,
                                                                    settings: {
                                                                        placeholder: "Select Variation",
                                                                        options: (subPremiumPlansOptions.find(plan => plan.value === data?.planConfiguration?.allowedPremiumPlans?.[idx]?.subPremiumPlanUuid)?.variations) || [],
                                                                        multiple: true,
                                                                        selectAll: true,
                                                                        searchable: true,
                                                                    },
                                                                }}
                                                            />
                                                        </Col>

                                                    }
                                                    <Col md={4}>
                                                        <Image
                                                            height={30}
                                                            width={30}
                                                            src={closeIcon}
                                                            className="remove-icon1"
                                                            onClick={() => this.removePlan(idx)}
                                                        ></Image>
                                                    </Col>
                                                </Row>
                                            ))
                                        }
                                        <Row>
                                            <Col md={12} className="">
                                                <button type="button" className="primary-btn pointer f-s-10 py-2 mt-3" onClick={this.addPlan}>+ Add Plan</button>
                                            </Col>
                                        </Row>
                                    </Col>
                                }

                                {/* other link i.e istfpallowd false  show link text input */}
                                {data?.planConfiguration?.allowSubscriptionPlanPage === true && data?.planConfiguration?.isTFPAllowed === false &&

                                    <Col md={4}>
                                        <FormElement
                                            valueLink={this.linkState(this, "data.planConfiguration.subscriptionPlanPageLink")}
                                            label="Subscription Plan Page Link"
                                            required
                                            validations={[
                                                {
                                                    validate: FormValidator.isRequired,
                                                    message: "Link cannot be empty",
                                                },
                                                {
                                                    validate: FormValidator.isUrl,
                                                    message: "Enter valid url",
                                                },
                                            ]}
                                            control={{
                                                type: CustomTextControl,
                                                settings: {
                                                    placeholder: "Enter Link",
                                                },
                                            }}
                                        />
                                    </Col>
                                }
                            </Row>
                        </Col>
                        <Col md={12}>
                            <Row>

                                <Col md={4} className="mt-3 f-s-14 roboto-grey">
                                    <p className="mb-2">Allow Partner to login TFP Admin Panel? <span class=" text-danger">*</span></p>
                                    <label htmlFor={"allowPartnerAdminPanelYes"} className="d-inline-block mr-3 pointer" >
                                        <input type="radio" id="allowPartnerAdminPanelYes" name="allowPartnerAdminPanel" checked={data?.adminPanelConfiguration?.allowPartnerAdminPanel === true} onChange={() => this.setState({ data: { ...data, adminPanelConfiguration: { ...data.adminPanelConfiguration, allowPartnerAdminPanel: true } } })} /> Yes
                                    </label>
                                    <label htmlFor={"allowPartnerAdminPanelNo"} className="d-inline-block mr-3 pointer" >
                                        <input type="radio" id={"allowPartnerAdminPanelNo"} name="allowPartnerAdminPanel" checked={data?.adminPanelConfiguration?.allowPartnerAdminPanel === false} onChange={() => this.setState({ data: { ...data, adminPanelConfiguration: { ...data.adminPanelConfiguration, allowPartnerAdminPanel: false, allowPartnerAdminUserDetails: false } } })} /> No
                                    </label>
                                </Col>
                                {data?.adminPanelConfiguration?.allowPartnerAdminPanel === true &&
                                    <Col md={4} className="mt-3 f-s-14 roboto-grey">
                                        <p className="mb-2">Allow Partner to view User Details? <span class=" text-danger">*</span></p>
                                        <label htmlFor={"allowPartnerAdminUserDetailsYes"} className="d-inline-block mr-3 pointer" >
                                            <input type="radio" id="allowPartnerAdminUserDetailsYes" name="allowPartnerAdminUserDetails" checked={data?.adminPanelConfiguration?.allowPartnerAdminUserDetails === true} onChange={() => this.setState({ data: { ...data, adminPanelConfiguration: { ...data.adminPanelConfiguration, allowPartnerAdminUserDetails: true } } })} /> Yes
                                        </label>
                                        <label htmlFor={"allowPartnerAdminUserDetailsNo"} className="d-inline-block mr-3 pointer" >
                                            <input type="radio" id={"allowPartnerAdminUserDetailsNo"} name="allowPartnerAdminUserDetails" checked={data?.adminPanelConfiguration?.allowPartnerAdminUserDetails === false} onChange={() => this.setState({ data: { ...data, adminPanelConfiguration: { ...data.adminPanelConfiguration, allowPartnerAdminUserDetails: false } } })} /> No
                                        </label>
                                    </Col>
                                }

                            </Row>

                        </Col>
                    </Row>

                    <hr />

                    {data.partnerType === sso && <>
                        <Row>
                            <Col md={12}>  <label className="primary f-s-18 inter-medium my-3">SSO Parent Child Configuration</label></Col>
                            <Col md={12} className="roboto-grey f-s-16">
                                <Row>
                                    <Col md={4} className="mt-3 f-s-14 roboto-grey">
                                        <p className="mb-2">Allow Parent-Child Relationship? <span class=" text-danger">*</span></p>
                                        <label htmlFor={"allowParentChildrenYes"} className="d-inline-block mr-3 pointer" >
                                            <input type="radio" id="allowParentChildrenYes" name="allowParentChildren" checked={data?.ssoConfiguration?.isParentChildrenAllowed === true} onChange={() => this.setState({ data: { ...data, ssoConfiguration: { ...data.ssoConfiguration, isParentChildrenAllowed: true } } })} /> Yes
                                        </label>
                                        <label htmlFor={"allowParentChildrenNo"} className="d-inline-block mr-3 pointer" >
                                            <input type="radio" id={"allowParentChildrenNo"} name="allowParentChildren" checked={data?.ssoConfiguration?.isParentChildrenAllowed === false} onChange={() => this.setState({ data: { ...data, ssoConfiguration: { ...data.ssoConfiguration, isParentChildrenAllowed: false } } })} /> No
                                        </label>
                                    </Col>
                                    {data.ssoConfiguration.isParentChildrenAllowed && <Col md={4} className="mt-3 f-s-14 roboto-grey">
                                        <p className="mb-2">Is Child allowed to access Membership page?
                                            <span class=" text-danger">*</span></p>
                                        <label htmlFor={"allowChildrenMemebershipPageYes"} className="d-inline-block mr-3 pointer" >
                                            <input type="radio" id="allowChildrenMemebershipPageYes" name="allowChildrenMemebershipPage" checked={data?.ssoConfiguration?.allowChildrenMemebershipPage === true} onChange={() => this.setState({ data: { ...data, ssoConfiguration: { ...data.ssoConfiguration, allowChildrenMemebershipPage: true } } })} /> Yes
                                        </label>
                                        <label htmlFor={"allowChildrenMemebershipPageNo"} className="d-inline-block mr-3 pointer" >
                                            <input type="radio" id={"allowChildrenMemebershipPageNo"} name="allowChildrenMemebershipPage" checked={data?.ssoConfiguration?.allowChildrenMemebershipPage === false} onChange={() => this.setState({ data: { ...data, ssoConfiguration: { ...data.ssoConfiguration, allowChildrenMemebershipPage: false } } })} /> No
                                        </label>

                                    </Col>}
                                </Row>
                            </Col>
                            <Col md={4} className="mt-3 f-s-14 roboto-grey">
                                <p className="mb-2">Can Users Update their Profile?<span class=" text-danger">*</span></p>
                                <label htmlFor={"canUpdateProfileYes"} className="d-inline-block mr-3 pointer" >
                                    <input type="radio" id="canUpdateProfileYes" name="canUpdateProfile" checked={data?.ssoConfiguration?.canUpdateProfile === true} onChange={() => this.setState({ data: { ...data, ssoConfiguration: { ...data.ssoConfiguration, canUpdateProfile: true } } })} /> Yes
                                </label>
                                <label htmlFor={"canUpdateProfileNo"} className="d-inline-block mr-3 pointer" >
                                    <input type="radio" id={"canUpdateProfileNo"} name="canUpdateProfile" checked={data?.ssoConfiguration?.canUpdateProfile === false} onChange={() => this.setState({ data: { ...data, ssoConfiguration: { ...data.ssoConfiguration, canUpdateProfile: false } } })} /> No
                                </label>
                            </Col>
                            {/* profile update table takding data from profilePermission */}
                            {data.ssoConfiguration.canUpdateProfile && <Col md={12} className="mt-3 f-s-14 roboto-grey">
                                <p className="mb-2">Profile Update Permissions<span class=" text-danger">*</span></p>
                                <table className="table custom-table f-s-16 w-50">
                                    <thead>
                                        <tr>
                                            <th>Permission</th>
                                            <th>Parent</th>
                                            {data.ssoConfiguration.isParentChildrenAllowed && <th>Child</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {profilePermissionConfig.map((item, i) => (
                                            <tr key={i}>
                                                <td>{item.label}</td>
                                                <td>
                                                    <input type="checkbox" checked={data?.ssoConfiguration?.[item.stateKey]?.PARENT} onChange={() => this.setState({ data: { ...data, ssoConfiguration: { ...data.ssoConfiguration, [item.stateKey]: { ...data.ssoConfiguration[item.stateKey], PARENT: !data.ssoConfiguration[item.stateKey]?.PARENT } } } })} />
                                                </td>
                                                {data.ssoConfiguration.isParentChildrenAllowed && <td>
                                                    <input type="checkbox" checked={data?.ssoConfiguration?.[item.stateKey]?.CHILD} onChange={() => this.setState({ data: { ...data, ssoConfiguration: { ...data.ssoConfiguration, [item.stateKey]: { ...data.ssoConfiguration[item.stateKey], CHILD: !data.ssoConfiguration[item.stateKey]?.CHILD } } } })} />
                                                </td>}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </Col>}
                            {/* cobrangin permison form cobraigpermision */}
                            <Col md={12} className="mt-3 f-s-16 roboto-grey">
                                <p className="mb-2">Cobranding Permissions<span class=" text-danger">*</span></p>
                                <table className="table custom-table f-s-16 w-50">
                                    <thead>
                                        <tr>
                                            <th>Permission</th>
                                            <th>Parent</th>
                                            {data.ssoConfiguration.isParentChildrenAllowed && <th>Child</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cobrandPermissionConfig.map((item, i) => (
                                            <tr key={i}>
                                                <td>{item.label}</td>
                                                <td>
                                                    <input type="checkbox" checked={data?.ssoConfiguration?.[item.stateKey]?.PARENT} onChange={() => this.setState({ data: { ...data, ssoConfiguration: { ...data.ssoConfiguration, [item.stateKey]: { ...data.ssoConfiguration[item.stateKey], PARENT: !data.ssoConfiguration[item.stateKey]?.PARENT } } } })} />
                                                </td>
                                                {data.ssoConfiguration.isParentChildrenAllowed && <td>
                                                    <input type="checkbox" checked={data?.ssoConfiguration?.[item.stateKey]?.CHILD} onChange={() => this.setState({ data: { ...data, ssoConfiguration: { ...data.ssoConfiguration, [item.stateKey]: { ...data.ssoConfiguration[item.stateKey], CHILD: !data.ssoConfiguration[item.stateKey]?.CHILD } } } })} />
                                                </td>}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </Col>

                        </Row>
                        <hr />
                    </>}
                    {data.partnerType === subdomain && <>
                        <Row>
                            <Col md={12}>  <label className="primary f-s-18 inter-medium my-3">Subdomain Configuration</label></Col>
                            <Col md={12} className="roboto-grey f-s-16">
                                <Row>
                                    <Col md={4} className="mt-3 f-s-14 roboto-grey">
                                        <FormElement
                                            valueLink={this.linkState(this, "data.subDomainConfiguration.pageTitle")}
                                            label="Web Page Title"
                                            control={{
                                                type: CustomTextControl,
                                                settings: {
                                                    placeholder: "Enter Web Page Title",
                                                },
                                            }}
                                        />
                                    </Col>
                                    <Col md={4} className="mt-3 f-s-14 roboto-grey">
                                        <FormElement
                                            valueLink={this.linkState(this, "data.subDomainConfiguration.pageDescription")}
                                            label="Web Page Description"
                                            control={{
                                                type: CustomTextControl,
                                                settings: {
                                                    placeholder: "Enter Web Page Description",
                                                },
                                            }}
                                        />
                                    </Col>
                                    <Col md={4} className="mt-3 f-s-14 roboto-grey">
                                        <ImageUploader id="favicon" label="Upload Favicon" name={data?.subDomainConfiguration?.favicon instanceof File || data?.subDomainConfiguration?.favicon instanceof Blob
                                            ? URL.createObjectURL(data?.subDomainConfiguration?.favicon)
                                            : data?.subDomainConfiguration?.favicon || ""}
                                            onChange={(e) => this.setState({ data: { ...data, subDomainConfiguration: { ...data.subDomainConfiguration, favicon: e.target?.files?.[0] } } })}
                                            onDelete={() => this.setState({ data: { ...data, subDomainConfiguration: { ...data.subDomainConfiguration, favicon: null } } })} showLabel={false} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <hr />
                    </>}

                    <Row>
                        <Col md={12}>
                            <label className="primary f-s-18 inter-medium my-3">Theme</label>
                        </Col>
                        <Col md={12}>
                            <label className="f-s-14">Primary</label>
                        </Col>

                        {/* Background + Text */}
                        <Col md={6} className="mb-3">
                            <div
                                className="d-flex justify-content-between align-items-center p-3"
                                style={{
                                    background: data.theme?.primaryBg,
                                    color: data.theme?.primaryText,
                                    borderRadius: 6,
                                    border: "1px solid #ddd",
                                }}
                            >
                                <span className="f-s-20">Primary Background + Text</span>

                                <div className="d-flex">
                                    <PopoverColorPicker
                                        value={data.theme?.primaryBg}
                                        onChange={(val) =>
                                            this.setState({
                                                data: {
                                                    ...data,
                                                    theme: { ...data.theme, primaryBg: val },
                                                },
                                            })
                                        }
                                    />
                                    <PopoverColorPicker
                                        value={data.theme?.primaryText}
                                        onChange={(val) =>
                                            this.setState({
                                                data: {
                                                    ...data,
                                                    theme: { ...data.theme, primaryText: val },
                                                },
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </Col>

                        {/* Button Preview */}
                        <Col md={6}>
                            <div
                                className="d-flex justify-content-between align-items-center p-3"
                                style={{
                                    border: "1px solid #ddd",
                                    borderRadius: 6,
                                }}
                            >
                                <button
                                    type="button"
                                    style={{
                                        background: data.theme?.primaryBtnBg,
                                        color: data.theme?.primaryBtnText,
                                        border: "none",
                                        padding: "8px 16px",
                                        borderRadius: 6,
                                    }}
                                    className="f-s-20"
                                >
                                    Primary Button
                                </button>

                                <div className="d-flex">
                                    <PopoverColorPicker
                                        value={data.theme?.primaryBtnBg}
                                        onChange={(val) =>
                                            this.setState({
                                                data: {
                                                    ...data,
                                                    theme: { ...data.theme, primaryBtnBg: val },
                                                },
                                            })
                                        }
                                    />
                                    <PopoverColorPicker
                                        value={data.theme?.primaryBtnText}
                                        onChange={(val) =>
                                            this.setState({
                                                data: {
                                                    ...data,
                                                    theme: { ...data.theme, primaryBtnText: val },
                                                },
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>


                    <hr />
                    <Row>
                        <Col md={12}>  <label className="primary f-s-18 inter-medium my-3">Modules</label></Col>
                        {/* filter  */}
                        <Col md={12}>
                            <label className="roboto-grey f-s-16">Filter by Creators</label>
                        </Col>
                        <Col md={12} className="d-flex align-items-end">
                            <label htmlFor="isTfpContentVisible">
                                <input
                                    type="checkbox"
                                    id="isTfpContentVisible"
                                    name="isTfpContentVisible"
                                    className="mr-1"
                                    checked={data?.isTfpContentVisible || false}
                                    onChange={(e) => {
                                        this.setState({ data: { ...data, isTfpContentVisible: e.target.checked } });
                                    }}
                                />{" "}
                                <label htmlFor="isTfpContentVisible" className="primary pointer">
                                    Allow TFP Content to be visible to this Partner
                                </label>
                            </label>
                        </Col>
                        <Col md={12} className="roboto-grey f-s-16">

                            <Row>


                                <Col md={4} className="">
                                    <FormElement
                                        valueLink={this.linkState(this, "data.contentCreators")}
                                        label="Creators"
                                        control={{
                                            type: SelectControl,
                                            settings: {
                                                placeholder: "Select Creators",
                                                options: this.state.creatorList,
                                                multiple: true,
                                                searchable: true,
                                                selectAll: true,
                                                onChangeCallback: () => {
                                                    let selectedValue = this.state.data.contentCreators || [];
                                                    getCampaignByFilterApi({ amc: this.state.data.amcs || "", creater: selectedValue, amcOption: this.state.amcOption, createrOptions: this.state.creatorList }).then((res) => {
                                                        let option = res?.map((item) =>
                                                        ({
                                                            label: item.campaignName,
                                                            value: item.uuid,
                                                        }));
                                                        this.setState({ campaignOptions: option || [] });
                                                    });
                                                    this.props.getTargetedContentSubdomainApi(this, { creator: selectedValue, amc: this.state.data.amcs || [] })
                                                },
                                            },
                                        }}
                                    />

                                </Col>
                                {
                                    (() => {
                                        const mfcOption = this.state.creatorList?.find(item => item.label === MUTUAL_FUND_COMPANY);
                                        if (mfcOption && this.state.data?.contentCreators?.includes(mfcOption.value)) {
                                            return <Col md={4} className="">
                                                <FormElement
                                                    valueLink={this.linkState(this, "data.amcs")}
                                                    label="AMCs"
                                                    control={{
                                                        type: SelectControl,
                                                        settings: {
                                                            placeholder: "Select Mutual Fund Companies",
                                                            options: this.state.amcOption,
                                                            multiple: true,
                                                            searchable: true,
                                                            selectAll: true,
                                                            onChangeCallback: () => {
                                                                let selectedValue = this.state.data.amcs || [];
                                                                getCampaignByFilterApi({ creater: this.state.data.contentCreators || "", amc: selectedValue, amcOption: this.state.amcOption, createrOptions: this.state.creatorList }).then((res) => {
                                                                    let option = res?.map((item) =>
                                                                    ({
                                                                        label: item.campaignName,
                                                                        value: item.uuid,
                                                                    }));
                                                                    this.setState({ campaignOptions: option || [] });
                                                                });
                                                                this.props.getTargetedContentSubdomainApi(this, { amc: selectedValue, creator: this.state.data.contentCreators || [] })
                                                                let modules = [...this.state.data.modules];
                                                                modules = modules?.map(item => {
                                                                    if ([MODULES.TARGETED_CONTENT, MODULES.CAMPAIGNS].includes(item.moduleName)) {
                                                                        return { ...item, uuids: "" }
                                                                    }
                                                                    else {
                                                                        return item;
                                                                    }
                                                                })
                                                                this.setState({ data: { ...data, modules } })
                                                            }
                                                        },
                                                    }}
                                                />

                                            </Col>
                                        }
                                        return null;

                                    })()
                                }

                            </Row>
                        </Col>
                        <Col md={12} className="roboto-grey mb-4 f-s-16">
                            <p>Select modules to be enabled for this partner.</p>
                        </Col>

                        {/* list of modules  */}
                        <Col md={12}>
                            {data.modules?.map((module, index) => {
                                return (
                                    <>
                                        {index > 0 && <><hr /><br /></>}
                                        <div className="d-flex flex-row justify-content-between">
                                            <p className="variation-srno">Module - {index + 1} </p>
                                            <Image
                                                height={30}
                                                width={30}
                                                src={closeIcon}
                                                className="remove-icon1"
                                                onClick={() => this.removeModules(index)}
                                            ></Image>
                                        </div>
                                        <br />
                                        <Row>
                                            <Col md={4}>
                                                <FormElement
                                                    valueLink={this.linkState(this, `data.modules.${index}.moduleName`)}
                                                    label={`Module Name`}
                                                    required
                                                    validations={[
                                                        {
                                                            validate: FormValidator.isRequired,
                                                            message: "Please enter module name",
                                                        },
                                                    ]}
                                                    control={{
                                                        type: SelectControl,
                                                        settings: {
                                                            placeholder: (module?.moduleName === MODULES.POST_PLANNER ? "CAMPAIGN PLANNER" : module?.moduleName) || "Select Module Name",
                                                            options: (() => {
                                                                const selectedModuleNames = this.state.data.modules.map(mod => mod.moduleName);
                                                                const moduleNameOptions = this.state.modulesList.map(mod => ({
                                                                    label: mod.moduleName === MODULES.POST_PLANNER ? "CAMPAIGN PLANNER" : mod.moduleName,
                                                                    value: mod.moduleName,
                                                                    uuid: mod.uuid,
                                                                }));
                                                                return moduleNameOptions?.filter(
                                                                    option => !selectedModuleNames.includes(option.value)
                                                                );
                                                            })(),
                                                            multiple: false,
                                                            searchable: true,
                                                            onChangeCallback: () => {
                                                                let modules = [...data.modules]
                                                                modules[index] = { moduleName: modules[index]?.moduleName }
                                                                modules[index].masterSsoPartnerModuleUuid = this.state.modulesList.find(item => item.moduleName === modules[index].moduleName)?.uuid || null
                                                                this.setState({ data: { ...data, modules } })
                                                            }
                                                        },

                                                    }}
                                                />
                                            </Col>

                                        </Row>
                                        {
                                            module.moduleName === MODULES.SEARCH &&
                                            <Row className="roboto-grey f-s-16 mt-3">
                                                <Col md={12}>
                                                    <label>Search Configuration</label>
                                                </Col>
                                                <Col md={12} className="d-flex flex-row">
                                                    {(() => {
                                                        const actions = [{ label: "Search on Header", value: "searchOnHeader" }, { label: "Search on Home Page", value: "searchOnHomaPage" }];
                                                        if (module?.searchOnHomaPage) {
                                                            actions.push({ label: "Trending Keyworks under Home Search", value: "trendingKeywords" })
                                                        }
                                                        return (<>
                                                            {actions.map((action) => (
                                                                <div key={action.value} md={1} className="mt-2">
                                                                    <label
                                                                        htmlFor={`${action.value}${index}`}
                                                                        className="d-inline-block mr-3 pointer"
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            id={`${action.value}${index}`}
                                                                            name={`${action.value}${index}`}
                                                                            className="mr-1"
                                                                            checked={module?.[action.value] || false}
                                                                            onChange={(e) => {
                                                                                const modules = [...this.state.data.modules];
                                                                                modules[index] = {
                                                                                    ...modules[index],
                                                                                    [action.value]: e.target.checked,
                                                                                };
                                                                                this.setState({ data: { ...data, modules } });
                                                                            }}
                                                                        />
                                                                        {action.label}
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </>)
                                                    })()}
                                                </Col>

                                            </Row>
                                        }

                                        {
                                            module.moduleName === MODULES.CONTENT &&
                                            <Row className="roboto-grey f-s-16 mt-3">
                                                <Col md={12}>
                                                    <label className="primary">Content Actions</label>
                                                </Col>
                                                <Col md={12} className="d-flex flex-row">
                                                    {(() => {
                                                        const actions = ["like", "share", "view", "save", "download", "cobrand"];
                                                        const canCobrand = data.modules?.[index]?.cobrand;
                                                        if (canCobrand) {
                                                            actions.push("cobrandTemplate");
                                                        }
                                                        return (<>
                                                            {actions.map((action) => (

                                                                <div key={action} md={1} className="mt-2">
                                                                    <label
                                                                        htmlFor={`${action}${index}`}
                                                                        className="d-inline-block mr-3 pointer"
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            id={`${action}${index}`}
                                                                            name={`${action}${index}`}
                                                                            checked={module?.[action] || false}
                                                                            onChange={(e) => {
                                                                                const modules = [...this.state.data.modules];
                                                                                modules[index] = {
                                                                                    ...modules[index],
                                                                                    [action]: e.target.checked,
                                                                                };
                                                                                this.setState({ data: { ...data, modules } });
                                                                            }}
                                                                        />{" "}
                                                                        {action.charAt(0).toUpperCase() + action.slice(1)}
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </>)
                                                    })()}
                                                </Col>


                                            </Row>
                                        }
                                        {
                                            module.moduleName === MODULES.CATEGORY &&
                                            <Row className="roboto-grey f-s-16 mt-3">
                                                <Col md={4}>
                                                    <FormElement
                                                        valueLink={this.linkState(this, `data.modules.${index}.uuids`)}
                                                        label="Select Category"
                                                        control={{
                                                            type: SelectControl,
                                                            settings: {
                                                                placeholder: "Select Category",
                                                                options: this.state.categoryOptions,
                                                                multiple: true,
                                                                searchable: true,
                                                                selectAll: true,
                                                            },
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                        {
                                            module.moduleName === MODULES.CAMPAIGN &&
                                            <Row className="roboto-grey f-s-16 mt-3">
                                                <Col md={4}>
                                                    <FormElement
                                                        valueLink={this.linkState(this, `data.modules.${index}.uuids`)}
                                                        label="Select Campaigns"
                                                        control={{
                                                            type: SelectControl,
                                                            settings: {
                                                                placeholder: "Select Campaigns",
                                                                options: this.state.campaignOptions,
                                                                multiple: true,
                                                                searchable: true,
                                                                selectAll: true,
                                                            },
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                        {
                                            module.moduleName === MODULES.TARGETED_CONTENT &&
                                            <Row className="roboto-grey f-s-16 mt-3">
                                                <Col md={4}>
                                                    <FormElement
                                                        valueLink={this.linkState(this, `data.modules.${index}.uuids`)}
                                                        label="Select Targeted Playlists"
                                                        control={{
                                                            type: SelectControl,
                                                            settings: {
                                                                placeholder: "Select Targeted Playlists",
                                                                options: this.state.targetedContentOptions,
                                                                multiple: true,
                                                                searchable: true,
                                                                selectAll: true,
                                                            },
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                        {
                                            module.moduleName === MODULES.EVENT && (
                                                <Row className="roboto-grey f-s-16 mt-3">
                                                    {/* Event Creator */}
                                                    <Col md={4}>
                                                        <FormElement
                                                            valueLink={this.linkState(this, `data.modules.${index}.eventOrganizer`)}
                                                            label="Select Event Organizer"
                                                            control={{
                                                                type: SelectControl,
                                                                settings: {
                                                                    placeholder: "Select Event Organizer",
                                                                    options: this.state.organizerList,
                                                                    multiple: true,
                                                                    searchable: true,
                                                                    selectAll: true,
                                                                },
                                                            }}
                                                        />
                                                    </Col>
                                                    {(() => {
                                                        const mfcOption = this.state.organizerList?.find(item => item.label === MUTUAL_FUND_COMPANY);
                                                        if (
                                                            mfcOption &&
                                                            this.state.data?.modules?.[index]?.eventOrganizer?.includes(mfcOption.value)
                                                        ) {
                                                            return (
                                                                <Col md={4}>
                                                                    <FormElement
                                                                        valueLink={this.linkState(this, `data.modules.${index}.eventAmcs`)}
                                                                        label="Select Event AMCs"
                                                                        control={{
                                                                            type: SelectControl,
                                                                            settings: {
                                                                                placeholder: "Select Mutual Fund Companies",
                                                                                options: this.state.amcOption,
                                                                                multiple: true,
                                                                                searchable: true,
                                                                                selectAll: true,
                                                                            },
                                                                        }}
                                                                    />
                                                                </Col>
                                                            );
                                                        }
                                                        return null;
                                                    })()}
                                                </Row>
                                            )
                                        }
                                        {
                                            module.moduleName === MODULES.NOTIFICATION && (
                                                <Row className="roboto-grey f-s-16 mt-3">
                                                    <Col md={4}>
                                                        {/* is notificationSettings  allowed*/}
                                                        <label
                                                            htmlFor="notificationSettings"
                                                            className="d-inline-block mr-3 pointer"
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                id={`notificationSettings`}
                                                                name={`notificationSettings`}
                                                                className="mr-1"
                                                                checked={module?.notificationSettings || false}
                                                                onChange={(e) => {
                                                                    const modules = [...this.state.data.modules];
                                                                    modules[index] = {
                                                                        ...modules[index],
                                                                        notificationSettings: e.target.checked,
                                                                    };
                                                                    this.setState({ data: { ...this.state.data, modules } });
                                                                }}
                                                            />{" "}
                                                            <label htmlFor="notificationSettings" className="primary pointer">Enable Notification Settings</label>

                                                        </label>

                                                    </Col>
                                                    <Col md={12}>
                                                        <label className="primary">Notification Platforms</label>
                                                    </Col>
                                                    <Col md={12} className="d-flex flex-row">
                                                        {(() => {
                                                            const platforms = [
                                                                { label: "Email", value: "notificationEmail" },
                                                                { label: "Web Push", value: "notificationWebPush" },
                                                                { label: "SMS", value: "notificationSms" },
                                                                { label: "WhatsApp", value: "notificationWhatsApp" },
                                                            ];

                                                            return platforms.map((platform) => (
                                                                <div key={platform.value} md={1} className="mt-2">
                                                                    <label
                                                                        htmlFor={`${platform.value}${index}`}
                                                                        className="d-inline-block mr-3 pointer"
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            id={`${platform.value}${index}`}
                                                                            name={`${platform.value}${index}`}
                                                                            className="mr-1"
                                                                            checked={module?.[platform.value] || false}
                                                                            onChange={(e) => {
                                                                                const modules = [...this.state.data.modules];
                                                                                modules[index] = {
                                                                                    ...modules[index],
                                                                                    [platform.value]: e.target.checked,
                                                                                };
                                                                                this.setState({ data: { ...this.state.data, modules } });
                                                                            }}
                                                                        />
                                                                        {platform.label}
                                                                    </label>
                                                                </div>
                                                            ));
                                                        })()}

                                                    </Col>

                                                </Row>
                                            )
                                        }
                                        {
                                            module.moduleName === MODULES.POST_PLANNER &&
                                            <Row className="roboto-grey f-s-16 mt-3">
                                                <Col md={12}>
                                            <label className="primary">
                                              Campaign Planner Actions</label>
                                                </Col>
                                                <Col md={12}>

                                                    {(() => {
                                                        const actions = [
                                                            { label: "Custom Plan", value: "customizedPlan" },
                                                            { label: "Manual Content", value: "manualContent" },
                                                        ];

                                                        return actions.map((action) => (
                                                            <label
                                                                htmlFor={`${action.value}${index}`}
                                                                className="d-inline-block mr-3 pointer"
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    id={`${action.value}${index}`}
                                                                    name={`${action.value}${index}`}
                                                                    className="mr-1"
                                                                    checked={module?.[action.value] || false}
                                                                    onChange={(e) => {
                                                                        const modules = [...this.state.data.modules];
                                                                        modules[index] = {
                                                                            ...modules[index],
                                                                            [action.value]: e.target.checked,
                                                                        };
                                                                        this.setState({ data: { ...data, modules } });
                                                                    }}
                                                                />
                                                                {action.label}
                                                            </label>
                                                        ));
                                                    })()}
                                                </Col>

                                                <Col md={12}>
                                                    <label className="primary">Campaign Planner Platforms</label>
                                                </Col>
                                                <Col md={12}>

                                                    {(() => {

                                                        const platforms = [
                                                            { label: "Email", value: "postPlannerEmail" },
                                                            { label: "WhatsApp", value: "postPlannerWhatsApp" },
                                                            { label: "Instagram", value: "postPlannerInstagram" },
                                                            { label: "Facebook", value: "postPlannerFacebook" },
                                                            { label: "Twitter(X)", value: "postPlannerTwitter" },
                                                            { label: "LinkedIn", value: "postPlannerLinkedin" },
                                                        ];
                                                        return platforms.map((platform) => (
                                                            <label
                                                                htmlFor={`${platform.value}${index}`}
                                                                className="d-inline-block mr-3 pointer"
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    id={`${platform.value}${index}`}
                                                                    name={`${platform.value}${index}`}
                                                                    className="mr-1"
                                                                    checked={module?.[platform.value] || false}
                                                                    onChange={(e) => {
                                                                        const modules = [...this.state.data.modules];
                                                                        modules[index] = {
                                                                            ...modules[index],
                                                                            [platform.value]: e.target.checked,
                                                                        };
                                                                        this.setState({ data: { ...data, modules } });
                                                                    }}
                                                                />
                                                                {platform.label}
                                                            </label>
                                                        ));
                                                    })()}

                                                </Col>
                                            </Row>
                                        }
                                        {
                                            module.moduleName === MODULES.AUTO_COBRAND &&
                                            <Row className="roboto-grey f-s-16 mt-3">
                                                <Col md={12}>
                                                    <label className="primary">Auto Cobrand Platforms</label>
                                                </Col>
                                                <Col md={12}>
                                                    {(() => {
                                                        const platforms = [
                                                            { label: "Email", value: "autoCobrandEmail" },
                                                            { label: "WhatsApp", value: "autoCobrandWhatsApp" },
                                                            { label: "Instagram", value: "autoCobrandInstagram" },
                                                            { label: "Facebook", value: "autoCobrandFacebook" },
                                                            { label: "Twitter(X)", value: "autoCobrandTwitter" },
                                                            { label: "LinkedIn", value: "autoCobrandLinkedin" },
                                                        ];
                                                        return platforms.map((platform) => (
                                                            <label
                                                                htmlFor={`${platform.value}${index}`}
                                                                className="d-inline-block mr-3 pointer"
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    id={`${platform.value}${index}`}
                                                                    name={`${platform.value}${index}`}
                                                                    className="mr-1"
                                                                    checked={module?.[platform.value] || false}
                                                                    onChange={(e) => {
                                                                        const modules = [...this.state.data.modules];
                                                                        modules[index] = {
                                                                            ...modules[index],
                                                                            [platform.value]: e.target.checked,
                                                                        };
                                                                        this.setState({ data: { ...data, modules } });

                                                                    }}
                                                                />
                                                                {platform.label}
                                                            </label>
                                                        ));

                                                    })()}
                                                </Col>
                                                <Col md={12}>
                                                    <label className="primary">Upload Section</label>
                                                </Col>
                                                <Col md={4}>
                                                    <FormElement
                                                        valueLink={this.linkState(this, `data.modules.${index}.uploadSections`)}
                                                        label="Select Upload Section"
                                                        control={{
                                                            type: SelectControl,
                                                            settings: {
                                                                placeholder: "Select Upload Section",
                                                                options: this.state.uploadSectionOptions,
                                                                multiple: true,
                                                                searchable: true,
                                                                selectAll: true,
                                                            },
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                        {
                                            module.moduleName === MODULES.TOOLS &&
                                            <Row className="roboto-grey f-s-16 mt-3">
                                                <Col md={4}>
                                                    <FormElement
                                                        valueLink={this.linkState(this, `data.modules.${index}.uuids`)}
                                                        label="Select Tools"
                                                        control={{
                                                            type: SelectControl,
                                                            settings: {
                                                                placeholder: "Select Tools",
                                                                options: this.state.toolsOption,
                                                                multiple: true,
                                                                searchable: true,
                                                                selectAll: true,
                                                            },
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                        {
                                            module.moduleName === MODULES.PERSONALIZE &&
                                            <Row className="roboto-grey f-s-16 mt-3">
                                                <Col md={4}>
                                                    <FormElement
                                                        valueLink={this.linkState(this, `data.modules.${index}.personalizationCategory`)}
                                                        label="Select Personalization Categories"
                                                        control={{
                                                            type: SelectControl,
                                                            settings: {
                                                                placeholder: "Select Personalization Categories",
                                                                options: this.state.personalizationCategoryOptions,
                                                                multiple: true,
                                                                searchable: true,
                                                                selectAll: true,
                                                            },
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                        {
                                            module.moduleName === MODULES.LANGUAGE &&
                                            <Row className="roboto-grey f-s-16 mt-3">
                                                <Col md={4}>
                                                    <FormElement
                                                        valueLink={this.linkState(this, `data.modules.${index}.uuids`)}
                                                        label="Select Languages"
                                                        control={{
                                                            type: SelectControl,
                                                            settings: {
                                                                placeholder: "Select Languages",
                                                                options: this.state.languageOption,
                                                                multiple: true,
                                                                searchable: true,
                                                                selectAll: true,
                                                            },
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                        {
                                            module.moduleName === MODULES.CALENDAR &&
                                            <Row className="roboto-grey f-s-16 mt-3">
                                                <Col md={4}>
                                                    <FormElement
                                                        valueLink={this.linkState(this, `data.modules.${index}.uuids`)}
                                                        label="Select Calendars"
                                                        control={{
                                                            type: SelectControl,
                                                            settings: {
                                                                placeholder: "Select Calendars",
                                                                options: this.state.personalizationCalendarOptions || [],
                                                                searchable: true,
                                                            },
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                    </>
                                )
                            })}
                        </Col>
                        <Col md={12}>
                            <Button disabled={this.state.modulesList?.length === data?.modules?.length} className="my-3 mt-5 primary-btn" onClick={this.addMore}>+ Add Module</Button>
                        </Col>
                    </Row>
                </Form>
            </section>
        );
    }
}

const mapStateToProps = (state) => ({
    masterCategoryState: state.MasterCategoryState,
    ssoState: state.SsoState
});

const mapDispatchToProps = {
    getAllSubscriptionsApi,
    getAllTypeApi,
    getAllAmcSsoApi,
    getAllModulesApi,
    getAllToolsApi,
    getAllCategoryApi,
    getTargetedContentSubdomainApi,
    getPersonalizationCategoryApi,
    getLanguageNameApi

};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddEditPartners));
